
import Vue from "vue";
import CatIcon from "@/components/atoms/CatIcon.vue";

export default Vue.extend<Data, Methods, {}, {}>({
  components: {
    CatIcon,
  },
  data() {
    return {};
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    async handleSkip() {
      try {
        await this.$store.dispatch("assistantCatModule/createAssistantCatMasterOnSkip");
        this.$emit("done");
        this.$emit("close");
      } catch (error) {
        console.error("Failed to skip writer type indicator:", error);
        this.$notify({
          title: this.$t("myPage.writerTypeIndicatorSkipConfirmDialog.errorMessage") as string,
          type: "error",
        });
      }
    },
  },
});

interface Data {}

interface Methods {
  handleClose: () => void;
  handleSkip: () => Promise<void>;
}
